import React from 'react';
import NewRequestForVendorCustomer from './NewRequestForVendorCustomer';

const NewRequest = () => {
  return <NewRequestForVendorCustomer />;
};

export default NewRequest;
